import React, { useEffect, useRef } from "react";
import "./CookieSettingsModal.css";

export default function CookieSettingsModal({
  isOpen,
  onClose,
  consent = {},
  onSave,
}) {
  const analytics = consent.analytics ?? false;
  const marketing = consent.marketing ?? false;
  const [localAnalytics, setLocalAnalytics] = React.useState(analytics);
  const [localMarketing, setLocalMarketing] = React.useState(marketing);
  const closeRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // reset form values from consent
      setLocalAnalytics(analytics);
      setLocalMarketing(marketing);
      // focus close button for keyboard users
      setTimeout(() => closeRef.current?.focus(), 40);
      // basic focus trap: add keydown to close on Esc
      const onKey = (e) => e.key === "Escape" && onClose();
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const newConsent = {
      necessary: true,
      analytics: !!localAnalytics,
      marketing: !!localMarketing,
      timestamp: Date.now(),
    };
    onSave(newConsent);
    onClose();
  };

  return (
    <div
      className="cookie-modal__backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie settings"
    >
      <div className="cookie-modal__panel">
        <h3 className="cookie-modal__title">Cookie settings</h3>
        <p className="cookie-modal__desc">
          Manage which cookies you allow. Necessary cookies are required for the
          site to work.
        </p>
        <div className="cookie-modal__controls">
          <div className="cookie-modal__row">
            <div className="cookie-modal__label">Necessary</div>
            <div className="cookie-modal__control">Always On</div>
          </div>
          <div className="cookie-modal__row">
            <div className="cookie-modal__label">Analytics</div>
            <label className="cookie-switch">
              <input
                type="checkbox"
                checked={localAnalytics}
                onChange={(e) => setLocalAnalytics(e.target.checked)}
              />
              <span className="cookie-switch__slider" />
            </label>
          </div>
          <div className="cookie-modal__row">
            <div className="cookie-modal__label">Marketing</div>
            <label className="cookie-switch">
              <input
                type="checkbox"
                checked={localMarketing}
                onChange={(e) => setLocalMarketing(e.target.checked)}
              />
              <span className="cookie-switch__slider" />
            </label>
          </div>
        </div>
        <div className="cookie-modal__actions">
          <button
            className="cookie-modal__btn cookie-modal__btn--save"
            onClick={handleSave}
          >
            Save
          </button>
          <button
            ref={closeRef}
            className="cookie-modal__btn cookie-modal__btn--cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
